import {Component} from "react";
import {withRouter} from 'react-router-dom';

class AnalyticsComponent extends Component {

    callAnalyticsTracker = () => {
        if (global._satellite && global._satellite.track) {
            let pageName = window.location.pathname;
            const homePage = "swacargo_com_ui";

            if (pageName.includes(homePage)) {
                if (pageName === "/" + homePage + "/" || pageName === "/" + homePage) {
                    pageName = "homepage"
                } else {
                    pageName = pageName.replace("/" + homePage + "/", "");
                }
            } else if (pageName.charAt(0) === "/") {
                pageName = pageName.substring(1);
            }

            global._satellite.track("otter", {page_name: pageName});
        }
    };

    componentDidUpdate(prevProps) {
        this.callAnalyticsTracker();
    }

    componentDidMount(prevProps) {
        this.callAnalyticsTracker();
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(AnalyticsComponent);



// WEBPACK FOOTER //
// ./src/components/AnalyticsComponent/AnalyticsComponent.js